export default {
  title: 'Create new project',
  backButton: 'All projects',
};
